import { render } from "./AllCustomers.vue?vue&type=template&id=e9f025d8&scoped=true"
import script from "./AllCustomers.vue?vue&type=script&lang=js"
export * from "./AllCustomers.vue?vue&type=script&lang=js"

import "./AllCustomers.vue?vue&type=style&index=0&id=e9f025d8&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9f025d8"]])

export default __exports__